import React, { createContext, useContext, useState, useEffect } from 'react';
import { getOrders} from './business/Order';

const OrderContext = createContext();

export const useOrderContext = () => useContext(OrderContext);

export const OrderProvider = ({ children }) => {
    const [orders, setOrders] = useState([]);
    const [departamentId, setDepartamentId] = useState(2);
    const [cancelData, setCancelData] = useState(null);
    
    useEffect(() => {
        getOrders(departamentId, setOrders);
        
        const updateInterval = setInterval(() => getOrders(departamentId, setOrders), 15000);
        
        return () => clearInterval(updateInterval);
    }, [departamentId]);


    return (
        <OrderContext.Provider value={{ 
                orders, departamentId, cancelData,
                setCancelData, setOrders, setDepartamentId
                }}>
            {children}
        </OrderContext.Provider>
    );
};
